import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { PasswordValidator } from '../shared/validators/password-validator';
import { TemplateService } from '../../templates/template.services';
import { UploadButtonService } from '../../utils/components/aon-upload-button/aon-upload-button.service';
import { ConfigurationModule } from './conf/configuration.module';
import { LogService } from './log/log.service';
import { PlatformService } from './services/platform.service';
import { LoggedInGuard } from './session/logged-in.guard';
import { NotLoggedInGuard } from './session/not-logged-in.guard';
import { SessionService } from './session/session.service';
import { StoreModule } from './store/store.module';
import { DialogService } from './utils/dialog.service';
import { SwalService } from './utils/swal.service';
import { ContextsService } from "../../contexts/contexts.service";
import { ActivatedRoute, ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Context } from "../../contexts/contexts.model";
import { Observable } from "rxjs";
import { SellersService } from '../../sellers/sellers.service';
import { Origin } from '../../origins/origins.model';
import { OriginsService } from '../../origins/origins.service';
import { Seller } from '../../sellers/sellers.model';

@Injectable()
export class ContextsResolver implements Resolve<Context[]> {

	public constructor(private contexts: ContextsService) {
	}

	public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Context[]> {
		return this.contexts.getAllContexts();
	}

}

@Injectable()
export class ContextResolver implements Resolve<Context> {

	public constructor(
		private contexts: ContextsService,
		private route: ActivatedRoute
	) {
	}

	public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Context> {
		const originCode = route.params['originCode'] || route.params['contextOriginCode'];
		return this.contexts.getContext(originCode);
	}

}

@Injectable()
export class SellersResolver implements Resolve<Seller[]> {
	public constructor(private sellersService: SellersService) {}

	public resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<Seller[]> {
		return this.sellersService.getSellers();
	}
}

@Injectable()
export class OriginsResolver implements Resolve<Origin[]> {

	public constructor(private originsService: OriginsService,) {
	}

	public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Origin[]> {
		return this.originsService.getOrigins();
	}
}

/**
 * This is the "core" module. It aggregates all custom made services.
 * This module should only be imported in the root module.
 */
@NgModule({
	imports: [ConfigurationModule.forRoot(), MomentModule, StoreModule],
	providers: [
		LogService,
		SessionService,
		SwalService,
		HttpClient,
		LoggedInGuard,
		NotLoggedInGuard,
		UploadButtonService,
		PasswordValidator,
		TemplateService,
		DialogService,
		PlatformService,
		ContextsService,
		ContextResolver,
		ContextsResolver,
		SellersService,
		SellersResolver,
		OriginsService,
		OriginsResolver
	]
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error(
				'CoreModule has already been loaded. Import Core modules in the AppModule only.'
			);
		}
	}
}
